import { render, staticRenderFns } from "./order-descript.vue?vue&type=template&id=0648bee0&scoped=true&"
import script from "./order-descript.vue?vue&type=script&lang=js&"
export * from "./order-descript.vue?vue&type=script&lang=js&"
import style0 from "./order-descript.vue?vue&type=style&index=0&id=0648bee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648bee0",
  null
  
)

export default component.exports